(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("rp-mq-breakpoints"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "rp-mq-breakpoints"], factory);
	else if(typeof exports === 'object')
		exports["jQueryModalLightbox"] = factory(require("jquery"), require("rp-mq-breakpoints"));
	else
		root["jQueryModalLightbox"] = factory(root["jquery"], root["rp-mq-breakpoints"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rpMqBreakpoints = __webpack_require__(2);
	
	var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Modal message box plugin for RacingPost
	 *
	 * @package Common
	 * @author Roman Kelemen <Roman_Kelemen@racingpost.com>
	 * @copyright Racingpost 2014
	 */
	
	/**
	 * finds barrier box in children of overlay
	 * @param jQuery overlay
	 */
	function selectBarrierBoxFromOverlay(overlay) {
	    return overlay.children('.ui-overlay__container').children('.rn-modal');
	}
	
	/**
	 /**
	  * Plugin  constructor
	  * @param {object} el Dom element object
	  *
	  * @param options = {
	  *      title: {string|boolean} Box title. If set to false, box will render without title
	  *          If title is empty, modal box will try to use element title from title attribute
	  *
	  *      autoOpen: {boolean} Open box right after initialisation
	  *
	  *      fade: {boolean} Use backdrop
	  *
	  *      parent: {string|jQuery} Parent element or css selector where box must be placed
	  *
	  *      cssClass: {string} Additional css classes for box container
	  *
	  *      template: {string} Modal box template. Next strings will be substituted by corresponding classes
	  *          {container} - container class
	  *          {close} - close icon class
	  *          {title} - title class
	  *          {content} - content css class
	  * }
	  * @constructor
	  */
	function RpModalBox(el, options) {
	    this._element = (0, _jquery2.default)(el);
	    this._box = null;
	    this._opened = false;
	    this._options = _jquery2.default.extend({
	        id: '',
	        autoOpen: true,
	        autoSize: true,
	        parent: 'body',
	        cssClass: '',
	        showClose: true,
	        autoClose: true,
	        iframeCssClass: '',
	        width: '',
	        height: '',
	        template: '<div class="ui-overlay js-overlay"> \
	    <div class="{container}"> \
	    <div class="{box}"> \
	    <svg class="{close} ui-icon ui-icon_sizeMedium"><use xlink:href="img/icons.svg#icon-cross"></use></svg> \
	    <div class="{content}"> \
	    </div></div></div></div>',
	        spinnerContainerClass: 'dummy-spinner-container-class',
	        overlayCssClass: '',
	        fixScrollTOp: false,
	        lightKeyboardFix: true
	    }, options);
	
	    this._firstClick = true;
	
	    this._init();
	}
	
	/**
	 * Plugin identifier
	 * @type {string}
	 */
	RpModalBox.pluginName = 'RpModalBox';
	
	/**
	 * Counter for opened boxes
	 * @type {number}
	 */
	RpModalBox.opened = 0;
	
	/**
	 * Used css classes
	 * @type {object}
	 */
	RpModalBox.css = {
	    overlay: 'ui-overlay',
	    container: 'ui-overlay__container js-overlay__container',
	    close: 'ui-modal__closeBtn',
	    box: 'ui-modal',
	    content: 'ui-modal__canvas'
	};
	
	/**
	 * Used events
	 * @type {object}
	 */
	RpModalBox.event = {
	    ns: '.modalBox',
	    rpNs: '.modalBox.rp',
	    show: 'show.modalBox.rp',
	    shown: 'shown.modalBox.rp',
	    hide: 'hide.modalBox.rp',
	    hidden: 'hidden.modalBox.rp',
	    updated: 'updated.modalBox.rp',
	    load: 'loading.modalBox.rp',
	    loaded: 'loaded.modalBox.rp',
	    contentLoaded: 'contentLoaded.modalBox.rp',
	    contentResized: 'contentResized.modalBox.rp',
	    breakpoint: 'breakpoint.modalBox.rp'
	};
	
	/**
	 * Performs plugin initialisation
	 * @private
	 */
	RpModalBox.prototype._init = function () {
	    var html = this._options.template.replace('{container}', this.constructor.css.container).replace('{close}', this.constructor.css.close).replace('{box}', this.constructor.css.box).replace('{content}', this.constructor.css.content);
	
	    this._box = (0, _jquery2.default)(html);
	    this._box.addClass(this._options.overlayCssClass).find('.' + this.constructor.css.box).addClass(this._options.cssClass).attr('id', this._options.id).css('width', this._options.width).css('min-height', this._options.height);
	
	    if (!this._options.showClose) {
	        this._box.find('.' + this.constructor.css.close).remove();
	    }
	
	    var contentBox = this._box.find('.' + this.constructor.css.content);
	    contentBox.append(this._element);
	
	    this._unbindEvents();
	    this._bindEvents();
	
	    if (this._element.is('iframe')) {
	        this._initIframe();
	    }
	
	    this._options.autoOpen && this.open();
	};
	
	/**
	 * Bind basic events to related elements
	 * @private
	 */
	RpModalBox.prototype._bindEvents = function () {
	    var self = this;
	    var closeSelector = '.' + this.constructor.css.close;
	    var boxSelector = '.' + this.constructor.css.box;
	
	    if (this._options.autoClose) {
	        (0, _jquery2.default)(document).bind('click' + this.constructor.event.rpNs, function (event) {
	            if (self._firstClick) {
	                self._firstClick = false;
	            } else if (self._opened && self._box.get(0) !== event.target && !self._box.has(event.target).size()) {
	                self.close();
	            }
	        });
	    }
	
	    this._box.bind('click' + this.constructor.event.rpNs, function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        if (self._options.autoClose) {
	            self.close();
	        }
	    });
	
	    if (this._options.showClose) {
	        this._box.find(closeSelector).bind('click' + this.constructor.event.rpNs, function (event) {
	            event.preventDefault();
	            self.close();
	        });
	    }
	
	    this._box.find(boxSelector).bind('click' + this.constructor.event.rpNs, function (event) {
	        event.stopPropagation();
	    });
	
	    this._element.bind(this.constructor.event.load, function () {
	        var innerDiv = (0, _jquery2.default)('<div/>');
	        innerDiv.addClass(self._options.spinnerContainerClass);
	        self._box.find('.' + self.constructor.css.content).append(innerDiv);
	        innerDiv.append('<svg class="ui-icon ui-icon_size2XL ui-animation_spinnerAnimation"><use xlink:href="img/icons.svg#icon-spinner"></use></svg>');
	    });
	
	    this._element.bind(this.constructor.event.loaded, function () {
	        self._box.find('.' + self._options.spinnerContainerClass).remove();
	    });
	
	    (0, _jquery2.default)(window).bind('rpBreakpointsSwitch.modalBox', this._onBreakpoint.bind(this));
	};
	
	/**
	 * Remove all events from windows object if no more active instances left
	 * @private
	 */
	RpModalBox.prototype._unbindEvents = function () {
	    if (this.constructor.opened === 0) {
	        (0, _jquery2.default)(window).unbind(this.constructor.event.ns);
	    }
	
	    (0, _jquery2.default)(document).unbind(this.constructor.event.ns);
	    (0, _jquery2.default)(this._element).unbind(this.constructor.event.ns);
	};
	
	/**
	 * Breakpoint change event handler
	 * Send message if target element is iframe
	 *
	 * @param {Event} event
	 * @private
	 */
	RpModalBox.prototype._onBreakpoint = function (event) {
	    if (!this._element.is('iframe')) {
	        return;
	    }
	
	    this._element[0].contentWindow.postMessage({
	        event: RpModalBox.event.breakpoint,
	        breakpoint: event.detail.breakpoint
	    }, '*');
	};
	
	/**
	 * Initialises iframe and binds default events
	 * Frame src will not be set
	 *
	 * @returns {HTMLElement} Initialised iframe jQuery object
	 * @private
	 */
	RpModalBox.prototype._initIframe = function () {
	    var self = this;
	    var iframe = this._element;
	    iframe.addClass(this._options.iframeCssClass);
	    iframe.hide();
	
	    this._element.trigger(this.constructor.event.load);
	
	    if (this._options.id && !iframe.attr('id')) {
	        iframe.attr('id', this._options.id + '-frame');
	    }
	
	    this._element.bind(this.constructor.event.contentLoaded, function (e, data, iframe) {
	        self._element.trigger(self.constructor.event.loaded);
	        self._element[0].contentWindow.postMessage({
	            event: self.constructor.event.breakpoint,
	            breakpoint: _rpMqBreakpoints2.default.current()
	        }, '*');
	
	        iframe.show();
	    });
	
	    this._options.autoSize && this._element.bind(this.constructor.event.contentResized, function (e, data, iframe) {
	        var alignItems = '';
	
	        if (data.contentHeight > (0, _jquery2.default)(window).height()) {
	            alignItems = 'baseline';
	        }
	        iframe.height(data.contentHeight);
	        (0, _jquery2.default)('.' + self.constructor.css.container).css({
	            '-webkit-box-align': alignItems,
	            '-webkit-align-items': alignItems,
	            '-ms-flex-align': alignItems,
	            'align-items': alignItems
	        });
	        self._fixiosVerticalCenter();
	    });
	
	    (0, _jquery2.default)(window).unbind('message', null, self._onMessage);
	    (0, _jquery2.default)(window).bind('message', { context: self }, self._onMessage);
	
	    return iframe;
	};
	
	/**
	 * On message event handler
	 *
	 * @param event
	 * @private
	 */
	RpModalBox.prototype._onMessage = function (event) {
	    var self = event.data.context,
	        event = event.originalEvent;
	
	    var eventName = event.data.name;
	    var regexp = new RegExp(self.constructor.event.ns.replace('.', '\\.'), 'g');
	
	    if (!eventName || !eventName.match(regexp)) {
	        return;
	    }
	
	    if (!event.data.target || event.data.target === self._options.id) {
	        self._element.trigger(eventName, [event.data, self._element]);
	    }
	};
	
	/**
	 * Open box
	 */
	RpModalBox.prototype.open = function () {
	    var _this = this;
	
	    if (this._opened) {
	        return;
	    }
	
	    this._element.trigger(this.constructor.event.show, [this._box]);
	
	    this._iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	    this._scrollTop = window.document.body.scrollTop;
	
	    /**
	     *  lightKeyboardFix is true by default,
	     *  this option is tested to figure out
	     *  is absolute position more helpful for frizzed lightboxes issue in iOS.
	     */
	
	    (0, _jquery2.default)(this._options.parent).append(this._box).css(Object.assign({ 'overflow-y': 'hidden', 'left': '0px', 'right': '0px', 'margin': 'auto' }, this._iOS && this._options.lightKeyboardFix ? {
	        position: 'absolute',
	        top: '0px'
	    } : null, this._iOS && !this._options.lightKeyboardFix ? {
	        top: '-' + this._scrollTop + 'px',
	        position: 'fixed'
	    } : null));
	
	    if (this._iOS && this._element.is('iframe')) {
	        /**
	         * Hack for iOS to handle focusing on input inside an iframe.
	         * Without this hack it often scrolls input above the screen.
	         * It's focusing normally only with fixed (or absolute) position.
	         * But it suddenly jumps to bottom if we start typing with fixed position.
	         */
	
	        var parentCssPosition = this._options.lightKeyboardFix ? 'absolute' : 'fixed';
	
	        this._element.load(function () {
	            try {
	                /**
	                 * It fails if we have no access to iframe's document due to security reasons.
	                 */
	                (0, _jquery2.default)(_this._element[0].contentDocument).on('focus.iOSIFrameFocusingHack', 'input:not(:checkbox)', function () {
	                    return (0, _jquery2.default)(_this._options.parent).css('position', 'relative');
	                }).on('blur.iOSIFrameFocusingHack', 'input:not(:checkbox)', function () {
	                    return (0, _jquery2.default)(_this._options.parent).css('position', parentCssPosition);
	                });
	            } catch (e) {}
	        });
	    }
	
	    this.constructor.opened++;
	    this._opened = true;
	    this._element.trigger(this.constructor.event.shown, [this._box]);
	    this._onAfterShow();
	};
	
	/**
	 * Post processor for when box is shown.
	 * @private
	 */
	RpModalBox.prototype._onAfterShow = function () {
	    this._fixiosVerticalCenter();
	};
	
	/**
	 * *used to be in gui-guide
	 * Fixed vertical center align for lightbox
	 * @private
	 */
	RpModalBox.prototype._fixiosVerticalCenter = function () {
	    if (navigator.userAgent.match(/iPhone|iPad|iPod/i) && this._box) {
	        var overlay = this._box;
	        var barrierBox = selectBarrierBoxFromOverlay(overlay);
	
	        // fixed not scrollable lightboxes
	        (0, _jquery2.default)(barrierBox).css({
	            "-webkit-overflow-scrolling": "touch !important",
	            "overflow": "scroll !important"
	        });
	
	        (0, _jquery2.default)(overlay).on('touchmove', function (e) {
	            barrierBox.trigger(e);
	        });
	    }
	};
	
	/**
	 * Triggeres inside close function before detaching element from DOM
	 * @private
	 */
	RpModalBox.prototype._onBeforeDetach = function () {
	    this._disfixiosVerticalCenter();
	};
	
	/**
	 * *used to be in gui-guide
	 * Removes fix artifacts
	 * @private
	 */
	RpModalBox.prototype._disfixiosVerticalCenter = function () {
	    var overlay = this._box;
	
	    overlay.off('touchmove');
	};
	
	/**
	 * Close box
	 */
	RpModalBox.prototype.close = function () {
	    if (!this._opened) {
	        return;
	    }
	
	    this._element.trigger(this.constructor.event.hide, [this._box]);
	    this._onBeforeDetach();
	    this._box.detach();
	
	    (0, _jquery2.default)(this._options.parent).css({
	        'overflow-y': '',
	        position: '',
	        top: ''
	    });
	    if (this._iOS) {
	        window.document.body.scrollTop = this._scrollTop;
	
	        if (this._element.is('iframe')) {
	            /**
	             * It fails if we have no access to iframe's document due to security reasons.
	             */
	            try {
	                (0, _jquery2.default)(this._element[0].contentDocument).off('.iOSIFrameFocusingHack');
	            } catch (e) {}
	        }
	    }
	
	    this.constructor.opened--;
	    this._opened = false;
	
	    this._element.trigger(this.constructor.event.hidden, [this._box]);
	};
	
	/**
	 * Destroy plugin data
	 */
	RpModalBox.prototype.destroy = function () {
	    this.close();
	    this._box = null;
	
	    this._unbindEvents();
	    _jquery2.default.data(this._element, this.constructor.pluginName, null);
	};
	
	/**
	 * jQuery modal dropdown plugin
	 *
	 * @param {string|object} params Object of options or plugin method to execute
	 * @param {*} args Arguments for methods
	 * @returns {$.fn}
	 */
	_jquery2.default.fn.rpModalBox = function (params, args) {
	    this.each(function () {
	        _jquery2.default.fn.rpModalBox.init(this, params, args);
	    });
	
	    return this;
	};
	
	/**
	 * Function for plugin initialisation
	 *
	 * @param {HTMLElement} el Element to apply plugin to
	 * @param {string|object} params Object of options or plugin method to execute
	 * @param {*} args Arguments for methods
	 */
	_jquery2.default.fn.rpModalBox.init = function (el, params, args) {
	    var key = RpModalBox.pluginName;
	    var object = _jquery2.default.data(el, key);
	    if (!object) {
	        _jquery2.default.data(el, key, new RpModalBox(el, params));
	    } else if (params && params[0] != '_' && object[params]) {
	        object[params].call(object, args);
	    }
	};
	
	/**
	 * Display standard message box
	 *
	 * @param {string} message Message to display
	 * @param {string} title Title of the box
	 * @param {object} buttons Object of buttons. It may be label-callback pairs or array of button-objects
	 * which must have two keys: html - jquery element of the button and click - onclick handler
	 *
	 * @returns {jQuery}
	 */
	_jquery2.default.rpModalBox = function (message, title, buttons) {
	    var content = _jquery2.default.rpModalBox._prepare(message, title, buttons);
	    return content.rpModalBox({ autoOpen: false }).rpModalBox('title', title).rpModalBox('open');
	};
	
	/**
	 * Displays error message
	 * @see $.rpModalBox() For parameters description
	 */
	_jquery2.default.rpModalBox.error = function (message, title, buttons) {
	    var content = _jquery2.default.rpModalBox._prepare(message, title, buttons);
	
	    return content.rpModalBox({ autoOpen: false, cssClass: 'error' }).rpModalBox('title', title).rpModalBox('open');
	};
	
	/**
	 * Displays error message
	 * @see $.rpModalBox() For parameters description
	 */
	_jquery2.default.rpModalBox.frame = function (url, options, params) {
	    var frame = (0, _jquery2.default)('<iframe width="100%" frameborder="0" scrolling="no" />');
	    params = _jquery2.default.extend({}, params);
	    options = _jquery2.default.extend({ autoOpen: true }, options);
	    _jquery2.default.each(params, function (attribute, value) {
	        frame.attr(attribute, value);
	    });
	
	    frame.attr('src', url);
	
	    (0, _jquery2.default)(window).unbind('contentLoaded.rpModalBox, contentResized.rpModalBox');
	
	    frame.rpModalBox(options);
	
	    return frame.bind('hidden.modalBox.rp', function () {
	        frame.rpModalBox('destroy');
	    });
	};
	
	/**
	 * Prepare html element of the box
	 *
	 * @see $.rpModalBox For parameters description
	 * @private
	 */
	_jquery2.default.rpModalBox._prepare = function (message, title, buttons) {
	    var content = (0, _jquery2.default)('<div><p>' + message + '</p></div>');
	    content.addClass(RpModalBox.css.lightboxContent);
	    if ((typeof buttons === 'undefined' ? 'undefined' : _typeof(buttons)) !== 'object') {
	        buttons = {
	            'Try again': function TryAgain(e) {
	                e.preventDefault();
	                this.rpModalBox('close');
	            }
	        };
	    }
	
	    _jquery2.default.each(buttons, function (label, params) {
	        var callback;
	        var button = (0, _jquery2.default)('<button class="button buttonLarge buttonLightMajor"><span></span></button>');
	
	        if (typeof params === 'function') {
	            callback = params;
	            button.find('span').text(label);
	        } else if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
	            callback = params.click || _jquery2.default.noop;
	            button = params.html ? params.html : button;
	        }
	        button.bind('click', callback.bind(content));
	        var wrapper = (0, _jquery2.default)('<div class="actionContainer"></div>');
	        wrapper.append(button).appendTo(content);
	    });
	
	    return content;
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=jquery.modal.lightbox.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-modal-lightbox/lib/jquery.modal.lightbox.js
// module id = 1781
// module chunks = 0